import { configureStore } from "@reduxjs/toolkit";
import userReducer from '../Redux/User/ReduxSliceUser';

// export default  const store = configureStore({
//     reducer:{
//         'user':userReducer,
//     }
// });

export const store = configureStore({
    reducer:{
        user:userReducer,
    }
})